/* STEP 2 · A7 (B-1e follow-up) — rows tagged "current period" but dated outside the engagement period are in NEITHER row
   population (journal entry testing, sampling): the backend's one rule is sampling_population.period_position. Both screens
   show the same line: the count and a list of the rows (``out_of_period_rows_excluded`` / ``out_of_period_rows``, the first
   200 of them). ``context`` "je" | "sampling" picks the sentence. Nothing shows when the count is 0. */
import { useResizableColumns, ResizableTable, ResizableTh } from "@/components/ui/resizable-table";   // Step 11d · add-on: adjustable columns
import React, { useState } from "react";
import { asArray } from "@/lib/asArray";
import { fmtDate } from "@/lib/dt";
import { fmtNumber, fmtCount } from "@/components/Amount";   // STEP 3 · rule 2 · B-2e: the one amount formatter

const money = (n) => fmtNumber(Number(n || 0));

export default function OutOfPeriodRows({ count, rows, context, t, lang, testid = "out-of-period" }) {
  const colW = useResizableColumns({ storageKey: "out-of-period-rows", defaults: [110, 130, 160, 110, 130, 130], mins: [72, 96, 100, 72, 90, 90] });   // Step 11d · add-on
  const [open, setOpen] = useState(false);
  const n = Number(count || 0);
  if (!n) return null;
  const list = asArray(rows);
  return (
    <div className="mt-1 text-[11px]" data-testid={testid}>
      <span data-testid={`${testid}-text`}>
        {t(`s2a7.outOfPeriod.${context === "sampling" ? "sampling" : "je"}`).replace("{n}", fmtCount(n))}
      </span>
      {list.length > 0 && (
        <button type="button" onClick={() => setOpen((v) => !v)} className="ms-2 underline text-emerald-700 dark:text-emerald-400"
                data-testid={`${testid}-toggle`}>
          {open ? t("s2a7.outOfPeriod.hide") : t("s2a7.outOfPeriod.show")}
        </button>
      )}
      {open && (
        <div className="mt-1 rounded border p-2" data-testid={`${testid}-list`}>
          <div className="mb-1 font-medium">{t("s2a7.outOfPeriod.title")}</div>
          {list.length < n && <div className="mb-1 text-muted-foreground">{t("s2a7.outOfPeriod.capped").replace("{cap}", fmtCount(list.length))}</div>}
          <div className="max-h-48 overflow-y-auto">
            <ResizableTable cols={colW} className="w-full">
              <thead className="border-b bg-slate-50 dark:bg-slate-900/40">
                <tr>
                  <ResizableTh index={0} className="px-2 py-1 text-start">{t("s2a7.outOfPeriod.col.voucher")}</ResizableTh>
                  <ResizableTh index={1} className="px-2 py-1 text-start">{t("s2a7.outOfPeriod.col.date")}</ResizableTh>
                  <ResizableTh index={2} className="px-2 py-1 text-start">{t("s2a7.outOfPeriod.col.where")}</ResizableTh>
                  <ResizableTh index={3} className="px-2 py-1 text-start">{t("s2a7.outOfPeriod.col.account")}</ResizableTh>
                  <ResizableTh index={4} className="px-2 py-1 text-end">{t("s2a7.outOfPeriod.col.debit")}</ResizableTh>
                  <ResizableTh index={5} className="px-2 py-1 text-end">{t("s2a7.outOfPeriod.col.credit")}</ResizableTh>
                </tr>
              </thead>
              <tbody className="divide-y">
                {list.map((r, i) => (
                  <tr key={r.gl_id || i} data-testid={`${testid}-row-${i}`}>
                    <td className="px-2 py-1 font-mono">{r.voucher_no || "—"}</td>
                    <td className="px-2 py-1">{fmtDate(r.entry_date, lang)}</td>
                    <td className="px-2 py-1">{r.position === "before" ? t("s2a7.outOfPeriod.before") : t("s2a7.outOfPeriod.after")}</td>
                    <td className="px-2 py-1 font-mono">{r.account_code || "—"}{r.account_name ? ` · ${r.account_name}` : ""}</td>
                    <td className="px-2 py-1 text-end tabular-nums">{money(r.debit)}</td>
                    <td className="px-2 py-1 text-end tabular-nums">{money(r.credit)}</td>
                  </tr>
                ))}
              </tbody>
            </ResizableTable>
          </div>
        </div>
      )}
    </div>
  );
}
